import React from 'react'
import { SeeProfileUser } from '../../Layout/SeeProfileUser-Layout-Component/SeeProfileUser'
import { ProfileUser } from '../../UI/ProfileUser-UI-Component/UIProfileHeader/ProfileUser'

export const SeeProfileUserPage = () => {
  return (
    <>
        <ProfileUser />
        <SeeProfileUser/>
    </>
  )
}
